import {
	clientStorageLocal,
	LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY,
} from '@ao/utils'

export const uploadFile = async (fileBlob, postUrl = 'files/') => {
	const apiUrl = import.meta.env.VITE_APP_BACK_API_URL
	const token = clientStorageLocal.get(LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY)

	const formData = new FormData()
	formData.append('file', fileBlob, 'downloaded_file')

	// Отправляем файл через POST-запрос
	const uploadResponse = await fetch(`${apiUrl}/${postUrl}`, {
			method: 'POST',
			body: formData,
			headers: {
				'Authorization': `Bearer ${token}`,
			},
	})

	if (!uploadResponse.ok) {
			throw new Error(`Ошибка при загрузке файла: ${uploadResponse.statusText}`)
	}

	return uploadResponse.json()
}

export const fetchFile = async (fileUrl) => {
	const response = await fetch(fileUrl)
	if (!response.ok) {
			throw new Error(`Ошибка при получении файла: ${response.statusText}`)
	}

	// Преобразуем ответ в Blob
	const fileBlob = await response.blob()

	return fileBlob
}

export const fetchAndUploadFile = async (fileUrl) => {
	const fileBlob = await fetchFile(fileUrl)
	const uploadedFile = await uploadFile(fileBlob)
	return uploadedFile
}
